/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Button, Container } from '@material-ui/core'
import { useKeycloak } from '@react-keycloak/web'
import Widget from '../Dashboard/Widget/Widget'
import { useStyles } from './Styles'
import Logo from '../Logo'

const NotAdminUser = () => {
  const { keycloak, initialized } = useKeycloak()

  const classes = useStyles()
  return (
    <div className={classes.AnonymousWrapper}>
      <Container maxWidth={'sm'} className={classes.AnonymousContainer}>
        <div>
          <Widget
            upperTitle
            disableWidgetMenu
            bodyClass={classes.AnonymousWidget}
          >
            <Logo/>
            <p><FormattedMessage id='NotAdminUser.message'/></p>
            <div className={classes.headerAuthWrapper + (!initialized ? ' hidden' : '')}>
              <FormattedMessage id='AnonymousAuth.message.please'/>
              <Button disableElevation disableRipple onClick={() => keycloak?.logout()}
                      className={classes.headerAuthLink}>
                <FormattedMessage id='UserMenu.logout'/>
              </Button>
            </div>
          </Widget>
        </div>
      </Container>

    </div>
  )
}

export default NotAdminUser
